<script setup lang="ts">
import { injectHubRowContext } from '@/modules/Workspaces/KnowledgeHub/Hubs/FileTable/context'
import type { IconName } from '@/uiKit/IconName'
import { computed } from 'vue'

type Action = {
  label: string
  icon: IconName
  props: Record<string, unknown>
}

const rowContext = injectHubRowContext()

const openAction = computed<Action>(() => {
  const label = 'Open'
  const icon = 'expand'
  const link = { url: rowContext.item.value.fields.file.manualValue || '', target: '_blank' }
  const props: Record<string, unknown> = {
    'aria-label': label,
  }

  if (link) {
    props.role = 'link'
    props['data-href'] = link.url
  }

  props.onClick = (e: Event) => {
    e.stopPropagation()
    if (link) {
      window.open(link.url, link.target)
    }
  }

  return { label, icon, props }
})
</script>

<template>
  <slot :open="openAction" />
</template>
